const STORAGE = 'user_auth_token';

export const getUserToken = () => localStorage.getItem(STORAGE);
export const setUserToken = (token: any) => localStorage.setItem(STORAGE, token);
export const deleteUserToken = () => localStorage.removeItem(STORAGE);